<template>
	<div class="">
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
			<v-icon color="info" @click="load">$reload</v-icon>
		</v-card-title>
		<v-card-title class="ptxxx-0">
			<v-form @submit.prevent="load" class="form-inline">
				<v-row class="">
					<v-col cols="12" class="d-flex align-center">
						<v-text-field outlined class="mr-2" dense v-model="query.name_like" label="名称" hide-details />
						<v-select
							outlined
							class="mr-2"
							dense
							label="状态"
							v-model="query.status"
							:items="refs['ShopAccountStatus']"
							item-title="title"
							item-value="value"
							hide-details
							clearable
						></v-select>
						<v-btn color="primary" class="mr-2" @click="load">
							<v-icon>$search</v-icon>
							查询
						</v-btn>
						<v-icon class="mr-2" v-if="queryPairs.length" @click="reset">$close</v-icon>
						<!-- <v-btn class="mr-2" @click="load" color="primary" outlined>刷新</v-btn> -->
						{{ total }}个
					</v-col>
				</v-row>
			</v-form>
		</v-card-title>
		<div class="d-flex flex-row flex-wrap align-center">
			<template v-for="(ca, i) in objects" :key="i">
				<v-card style="max-width: 160px" class="mr-1 mb-1">
					<v-card-title>{{ ca.name }}({{ ca.id }})</v-card-title>
					<v-card-subtitle>{{ ca.description }}</v-card-subtitle>
					<v-card-actions>
						<slot name="actions" v-bind="{ ca, selected }">
							<v-btn class="ml-2 mt-2" :color="ca.color" outlined>选择</v-btn>
						</slot>
					</v-card-actions>
				</v-card>
			</template>
			<v-btn v-if="more" @click="load">加载更多</v-btn>
		</div>
	</div>
</template>

<script>
import { clone, valuesIn, toPairsIn, filter, intersection } from 'lodash-es'
import qs from 'qs'

export default {
	components: {},
	props: {
		initQuery: { type: Object, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => [
				{ text: '#', value: 'id' },
				{ text: '名称', align: 'left', sortable: true, value: 'name' },
				{ text: '类型', value: 'type' },
				{ text: '余额', value: 'balance' },
				{ text: '状态', value: 'status' },
				{ text: '', align: 'left', sortable: false, value: 'action' }
			]
		}
	},
	data() {
		const qps = qs.parse(location.search, { ignoreQueryPrefix: true })
		return {
			query: qps,
			currentQuery: {}, //当前结果的查询条件
			objects: [],
			total: 0,
			pageno: 1,
			pagesize: 10,
			loading: false,
			options: {},
			refs: {},
			selected: [],
			errors: {},
			more: true
		}
	},
	mounted() {
		if (this.initQuery) {
			this.query = clone(this.initQuery)
		}
		this.$api.common.meta('shop', 'ShopAccountStatus,ShopAccountType', (response) => {
			this.refs = response
		})
		this.load()
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {
		options: {
			handler() {
				this.load()
			},
			deep: true
		}
	},
	methods: {
		// search() {
		// 	if (
		// 		this.queryValues.length !== this.currentQueryValues.length ||
		// 		intersection(this.queryValues, this.currentQueryValues).length !== this.queryValues.length
		// 	) {
		// 		//条件变化
		// 		if (this.options.page === 1) {
		// 			//当前如果是第一页，手动触发
		// 			this.load()
		// 		} else {
		// 			this.options.page = 1 //当前不是第一页，修改后通过watcher触发
		// 		}
		// 	} else {
		// 		//条件没变，忽略
		// 	}
		// },
		reset() {
			this.query = {}
		},
		queryChanged(cur, newQuery) {
			console.log('check query changed', cur, newQuery)
			let changed =
				cur.length !== newQuery.length || intersection(valuesIn(cur), valuesIn(newQuery)).length !== cur.length
			console.log('changed', changed)
			return changed
		},
		load(options) {
			// let { sortBy, page, itemsPerPage } = options || {}
			this.loading = true
			if (this.queryChanged(this.currentQuery, this.query)) {
				this.pageno = 1
				this.objects = []
			}
			let qwp = clone(this.query)
			qwp.pageno = this.pageno
			qwp.pagesize = this.pagesize
			qwp.sortBy = 'id'
			qwp.sortDesc = 'desc'
			this.currentQuery = clone(this.query)
			this.$api.shop.searchAccount(
				qwp,
				(response) => {
					this.objects = [...this.objects, ...response.objects]
					this.total = response.total
					this.loading = false
					if (response.objects.length < this.pagesize) {
						this.more = false
					} else {
						this.pageno++
					}
				},
				(error) => {
					this.errors = error.message
					this.loading = false
				}
			)
		}
	}
}
</script>

<style scoped>
.silent td {
	color: rgba(3, 3, 3, 0.5) !important;
}
</style>
